/* Carrusel flotante de prueba social — Davie Lake View
   Marquee con transform:translateX (sin flicker), loop sin costuras,
   auto-movimiento + arrastre (mouse y touch). Pausa al interactuar / hover. */
(function () {
  'use strict';
  var root = document.getElementById('davie-proof-carousel');
  if (!root) return;
  var vp = root.querySelector('.davie-carousel__viewport');
  var track = root.querySelector('.davie-carousel__track');

  // Duplicar los slides originales para el loop
  var originals = Array.prototype.slice.call(track.children);
  originals.forEach(function (s) { track.appendChild(s.cloneNode(true)); });

  var offset = 0, setWidth = 0;
  var speed = 0.45;               // px por frame
  var paused = false, dragging = false;
  var startX = 0, startOffset = 0, idle = null;

  function measure() {
    var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
    setWidth = 0;
    originals.forEach(function (s) { setWidth += s.getBoundingClientRect().width + gap; });
  }
  measure();
  window.addEventListener('resize', function () { measure(); });

  function norm(x) { return setWidth > 0 ? ((x % setWidth) + setWidth) % setWidth : 0; }
  function apply() { track.style.transform = 'translate3d(' + (-offset) + 'px,0,0)'; }

  function tick() {
    if (!paused && !dragging) { offset = norm(offset + speed); apply(); }
    requestAnimationFrame(tick);
  }
  requestAnimationFrame(tick);

  function nudgeIdle() { clearTimeout(idle); idle = setTimeout(function () { paused = false; }, 2500); }

  vp.addEventListener('pointerdown', function (e) {
    dragging = true; paused = true; vp.classList.add('is-dragging');
    startX = e.clientX; startOffset = offset;
    try { vp.setPointerCapture(e.pointerId); } catch (err) {}
  });
  vp.addEventListener('pointermove', function (e) {
    if (!dragging) return;
    offset = norm(startOffset - (e.clientX - startX));
    apply();
  });
  function endDrag() { if (dragging) { dragging = false; vp.classList.remove('is-dragging'); nudgeIdle(); } }
  vp.addEventListener('pointerup', endDrag);
  vp.addEventListener('pointercancel', endDrag);

  vp.addEventListener('mouseenter', function () { paused = true; });
  vp.addEventListener('mouseleave', function () { endDrag(); paused = false; });
})();
